import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import {NgForm} from '@angular/forms';

import { PredialService } from "../../servicios/servicio.index";


@Component({
  selector: 'app-predial',
  templateUrl: './predial.component.html',
  styleUrls: ['./predial.component.css']
})
export class PredialComponent implements OnInit {
  imagenes: any[] = [];
  mensaje: any;
  loading = true;
  type = "image";
  theme = "Light";
  size = "inline";
  lang = "es";
  captcha = false;
  master: any = {
    clave_catastral: ""
  };

  forma: any = { ...this.master };
  mostrar = false;
  constructor(public router: Router,
    private _predialService: PredialService
    ) {

      this.getImagenes();
     this.getMostrar();

     }


     onSubmit(f: NgForm) {
      console.log(f.value);  // { first: '', last: '' }
      console.log(f.valid);  // false
    }
  ngOnInit(): void {
    console.log(this.mostrar)
  }

  buscar() {
    console.log(this.forma);
    console.log('entraaaa');
    
    this._predialService.getConsulta(this.forma.clave_catastral).subscribe(
      data => {
        console.log(this.forma);
        this.router.navigateByUrl("/consulta_saldo", {
          state: { clave_catastral: this.forma.clave_catastral }
        });
      },
      err => {
        console.log(err)
        this.mensaje = "¡Clave Catastral Incorrecta o no existe!";
      }
    );
  }

  getImagenes() {
    this._predialService.getImagenes().subscribe(
      data => {
        this.imagenes = data.registros;
      },
      err => { }
    );
  }

  getMostrar() {
    this._predialService.getMostrar().subscribe(
      data => {
        console.log(data);
        this.mostrar = data.registro;
      },
      err => { }
    );
  }

 
}
